import { Component, OnInit, Input, OnDestroy} from '@angular/core';
import { localMeasurementElevationName } from 'src/app/_helpers/extensions.module';
import { ChartData, ChartingService } from 'src/app/_services/charting.service';
import { ExternalWorkoutService } from 'src/app/_services/generatedServices';


@Component({
  selector: 'external-elevation-chart',
  templateUrl: 'elevation-chart.component.html',
})
export class ExternalElevationChartComponent implements OnInit, OnDestroy {
  initialized = false;
  hasData: boolean = true;
  localMeasurementElevationName: string;

  @Input()
  clientProgramWorkoutDayId: number;

  @Input()
  isMetricSystem: boolean = false;


  constructor(private charting: ChartingService, private externalWorkoutService: ExternalWorkoutService) {}

  ngOnInit(): void {
    this.localMeasurementElevationName = localMeasurementElevationName();
    const title = 'Elevation (' + (this.localMeasurementElevationName) + ')';
    const chartHeaders: any[] = [{ type: 'timeofday', id: 'Time', label: 'Time' }, { type: 'number', id: 'Elevation', label: title }];

    this.externalWorkoutService.getElevationChartData(this.clientProgramWorkoutDayId, this.isMetricSystem).subscribe(result => {
      this.hasData = result.length > 0;

      this.charting.queueCharts(
        this.charting.drawAreaChart.bind(this.charting),
        new ChartData(
            'elevationChart',
            chartHeaders,
            result.map(x => [x.timerDuration, Math.round(x.value)]),
            title
        )
      );
      this.initialized = true;
    });
  }

  ngOnDestroy() {
    this.charting.unsubscribe();
  }
}
